module.exports = __webpack_public_path__ + "static/media/CNT_Logo_Color_-01 copy.a7716a37.svg";